export interface Roles {
    adminGroup: boolean;
    adminBusiness: boolean;
    operator: boolean;
    sysAdmin?: boolean;
    sysOperator?: boolean;
    ondemand?: boolean;
}

export function defaultRoles() {
    return {
        adminGroup: false,
        adminBusiness: false,
        operator: true,
        ondemand: false,
        sysAdmin: false,
        sysOperator: false
    }
}